import { render, staticRenderFns } from "./KnowCountry.vue?vue&type=template&id=ed741074&scoped=true"
import script from "./KnowCountry.vue?vue&type=script&lang=js"
export * from "./KnowCountry.vue?vue&type=script&lang=js"
import style0 from "./KnowCountry.vue?vue&type=style&index=0&id=ed741074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed741074",
  null
  
)

export default component.exports